import { Grid, Switch } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useState } from "react";
import { useAgencyInfo } from "context/agency";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import env from "config";
import SoftTypography from "components/SoftTypography";
import FormField from "layouts/pages/account/components/FormField";
import { uploadImageToGhl } from "hook/services";
import ReactCropModal from "../../ReactCropModal/ReactCropModal";
import LogoUpload from "./LogoUpload";
import BrandLogosSection from "./BrandLogosSection";
import TopbarStylingSection from "./TopbarStylingSection";
import SEOSection from "./SEOSection";
// Font constants are now imported directly in components that need them


function General({ handleImage, loading, handelThemeData, selectedTheme, buttonLoading }) {
  const inputData = selectedTheme?.theme_data?.general;
  const [agency] = useAgencyInfo();
  const customUrlDomain = env.ACCOUNT_LEVEL_URL;
  const SERVER_IP = env.SERVER_IP;
  const [logo, setlogo] = useState(inputData?.logo || "");
  const [Meta_logo, setMeta_logo] = useState(inputData?.Meta_logo || "");
  const [domainupdate, setDomainupdate] = useState(false);
  const [Footer_logo, setFooter_logo] = useState(inputData?.footer_logo || "");
  const [Auth_logo, setAuth_logo] = useState(inputData?.auth_logo || "");
  const [previewFooterLogo, setPreviewFooterLogo] = useState(
    Footer_logo ||
      "https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/b5738fa2-b05a-46db-a2c2-0c0612c76ae2.png"
  );
  const [previewAuthLogo, setPreviewAuthLogo] = useState(
    Auth_logo ||
      "https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/a742c392-3573-4833-a324-d6e51090ee28.png"
  );
  const [previewLogo, setPreviewLogo] = useState(
    logo ||
      "https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/fff1c682-9973-4054-afce-285e5b950f05.png"
  );
  const [previewMetaLogo, setPreviewMetaLogo] = useState(
    Meta_logo ||
      "https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/bd948045-7012-4b81-8dfe-8f585c519511.png"
  );
  const [ghl_connect_logo, setGhl_connect_logo] = useState(inputData?.ghl_connect_logo || "");
  const [openWhitelabelModal, setopenWhitelabelModal] = useState(false);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [currentImageType, setCurrentImageType] = useState("");

  const url = inputData?.domain
    ? `https://${agency.domain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`
    : `${customUrlDomain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`;

  const openCropModal = (file, type) => {
    setCurrentImage(URL.createObjectURL(file));
    setCurrentImageType(type);
    setCropModalOpen(true);
  };

  const handleCroppedImage = async (blob) => {
    if (!blob) return;

    try {
      const file = new File([blob], "cropped-image.jpg", { type: "image/jpeg" });
      const image_response = await uploadImageToGhl(file, agency);

      if (!image_response?.data) {
        console.error("Image upload failed");
        return;
      }

      // Update the appropriate state based on image type
      if (currentImageType === "logo") {
        setlogo(image_response.data);
        setPreviewLogo(URL.createObjectURL(blob));
        handleImage(image_response.data, "logo");
      } else if (currentImageType === "footer_logo") {
        setFooter_logo(image_response.data);
        setPreviewFooterLogo(URL.createObjectURL(blob));
        handleImage(image_response.data, "footer_logo");
      } else if (currentImageType === "auth_logo") {
        setAuth_logo(image_response.data);
        setPreviewAuthLogo(URL.createObjectURL(blob));
        handleImage(image_response.data, "auth_logo");
      } else if (currentImageType === "Meta_logo") {
        setMeta_logo(image_response.data);
        setPreviewMetaLogo(URL.createObjectURL(blob));
        handleImage(image_response.data, "Meta_logo");
      }

      setCropModalOpen(false);
    } catch (error) {
      console.error("Error processing cropped image:", error);
    }
  };

  const handleImageUpload = (e, type) => {
    const file = e.target.files?.[0];
    if (file) {
      openCropModal(file, type);
      // Reset input value so same file can be selected again
      e.target.value = "";
    }
  };

  const handleSubmit = async (e, val) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const formObject = {};
    formData.forEach((value, key) => {
      formObject[key] = value;
    });
    
    // Keep all data in general object for backward compatibility with existing pages
    if (val) {
      formObject.extraValue = val;
    }
    
    handelThemeData({ general: formObject });
  };
  return (
    <div>
      <SoftBox component="form" onSubmit={(e) => handleSubmit(e, "someValue")}>
        <Grid container spacing={3} rowSpacing={2} paddingX={3} paddingBottom={4}>
          {/* Left Half - Brand Logos */}
          <BrandLogosSection
            logo={logo}
            previewLogo={previewLogo}
            Auth_logo={Auth_logo}
            previewAuthLogo={previewAuthLogo}
            Footer_logo={Footer_logo}
            previewFooterLogo={previewFooterLogo}
            Meta_logo={Meta_logo}
            previewMetaLogo={previewMetaLogo}
            handleImageUpload={handleImageUpload}
            inputData={inputData}
          />

          {/* Right Half - Topbar Styling */}
          <TopbarStylingSection
            inputData={inputData}
          />

          {/* SEO Card */}
          <SEOSection inputData={inputData} />

          <Grid item xs={12} className="px-2" display="flex" justifyContent={"end"}>
            <button className="btn-new-design-black" disabled={buttonLoading} type="submit">
              {buttonLoading ? "Loading..." : " Update"}
            </button>
          </Grid>
          {openWhitelabelModal && (
            <div className="modal-zz-confirm" onClick={() => setopenWhitelabelModal(false)}>
              <div
                className="scrollable-modal-content bg-white  rounded"
                style={{ border: "1px solid black ", position: "relative" }}
              >
                <h2 className="text-center font-14"> Connect white label domain</h2>
                <span className="crossison">X</span>
                <div className="list-model0">
                  <p>
                    Connect your own domain to the system (without https://)
                    maybetech.yourdomain.com
                  </p>
                  <p>
                    {" "}
                    You can use any domain you own or you can create a sub-domain like
                    maybetech.yourdomain.com to get white-labeled access to the platform.
                  </p>
                  <ul>
                    <li className="listtext">
                      <b>1.</b> Refer to your domain registrar&apos;s control panel, choose desired
                      domain zone.
                    </li>

                    <li className="listtext">
                      {" "}
                      <b>2.</b>Create a record of{" "}
                      <u>
                        <b>ANAME</b>
                      </u>{" "}
                      type, enter your domain/subdomain name and point it to{" "}
                      <u>
                        <b>{SERVER_IP}</b>
                      </u>{" "}
                    </li>
                    <li className="listtext">
                      {" "}
                      <b>3.</b> We will do the rest!{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Grid>
      </SoftBox>

      {/* Image Crop Modal */}
      {/* <Dialog open={cropModalOpen} onClose={() => setCropModalOpen(false)} maxWidth="md" fullWidth>
        <DialogContent>
          <SoftTypography variant="h5" gutterBottom>
            Crop Image
          </SoftTypography>
          <Box display="flex" flexDirection="column" alignItems="center">
        
            <ReactCropModal
        open={cropModalOpen}
        onClose={() => setCropModalOpen(false)}
        currentImage={currentImage}
        onCropComplete={handleCroppedImage}
        // aspectRatio={currentAspectRatio}
      />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCropModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleCroppedImage}
            variant="contained"
            color="primary"
            // disabled={!completedCrop}
          >
            Apply Crop
          </Button>
        </DialogActions>
      </Dialog> */}
      <ReactCropModal
        open={cropModalOpen}
        onClose={() => setCropModalOpen(false)}
        currentImage={currentImage}
        onCropComplete={handleCroppedImage}
      />
    </div>
  );
}

export default General;
